import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaRegHeart, FaBagShopping, FaUser } from 'react-icons/fa6';
import { FiUser, FiLogOut, FiChevronDown } from 'react-icons/fi';
import { useAuth } from '../../user/AuthContext';
import { useGlobal } from '../../../global/GlobalContext';
import { BiChevronLeft } from 'react-icons/bi';

const MobileHeader = ({title, ProductsCount, link}) => {
  const { userToken, logout } = useAuth();
  const { cart, wishlist } = useGlobal();
  const navigate = useNavigate();

  const cartCount = cart.length;
  const wishlistCount = wishlist.length;

  return (
    <>
      {/* Navbar */}
      <header className="bg-white z-50 w-full sticky top-0 lg:hidden">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8 flex flex-wrap justify-between items-center">
          {/* mobile start */}
          <div className='flex gap-2 items-center'>
            <button className='text-xl z-40' onClick={() => navigate(-1)}>
              <BiChevronLeft />
            </button>
              <div className='text-xs font-medium flex flex-col gap-1 title_top'>
                  
                  {link?(<Link to={link}>{title}</Link>):{title}}
                  {ProductsCount && (
                    <span className='text-[10px] font-light'>{ProductsCount}</span>
                  )}
                  
              </div>
          </div>
          
          {/* mobile end */}
 
          <div className="flex items-center gap-5">
            <div className="hidden md:flex">
              {userToken ? (
                <div className="relative group">
                  <button className="flex items-center gap-1.5 text-gray-700 hover:text-brand-600 transition-colors py-2">
                    <FaUser size={15} />
                    <FiChevronDown size={13} className="opacity-60 group-hover:rotate-180 transition-transform" />
                  </button>

                  <div className="hidden group-hover:block absolute right-0 top-full pt-1 z-50">
                    <div className="w-44 rounded-xl border border-gray-100 bg-white shadow-lg py-1.5 overflow-hidden">
                      <Link
                        to={'/myaccount'}
                        className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 hover:text-brand-600 transition-colors"
                      >
                        <FiUser size={15} /> My Account
                      </Link>
                      <button
                        onClick={logout}
                        className="flex items-center gap-2.5 w-full px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 transition-colors"
                      >
                        <FiLogOut size={15} /> Logout
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Link to="/login" className="text-sm font-semibold text-gray-700 hover:text-brand-600 transition-colors">LOGIN / SIGNUP</Link>
              )}
            </div>

            <Link to="/wishlist" className="relative">
              <FaRegHeart className='text-black' />
              {wishlistCount > 0 && (
                <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 text-xs text-white bg-badge-orange rounded-full w-4 h-4 flex items-center justify-center">
                  {wishlistCount}
                </span>
              )}
            </Link>

            <Link to="/cart" className="relative">
              <FaBagShopping className='text-black'  />
              {cartCount > 0 && (
                <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 text-xs text-black border bg-white rounded-full w-4 h-4 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
          
        </div>
      </header>
    </>
  );
};

export default MobileHeader;

